class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'pet-dtc-recently-viewed';
    this.currentHandle = this.dataset.currentProductHandle;
    this.sectionId = this.dataset.sectionId;
    this.productUrlBase = this.dataset.productUrlBase;
    this.productsToShow = Number(this.dataset.productsToShow) || 4;

    if (!this.currentHandle || !this.sectionId || !this.productUrlBase) return;

    const storedHandles = this.readHandles();
    this.handlesToDisplay = storedHandles
      .filter((handle) => handle !== this.currentHandle && this.isValidHandle(handle))
      .slice(0, this.productsToShow);

    const nextHandles = [this.currentHandle, ...storedHandles.filter((handle) => handle !== this.currentHandle)]
      .filter((handle) => this.isValidHandle(handle))
      .slice(0, 12);
    this.writeHandles(nextHandles);

    if (this.handlesToDisplay.length === 0) return;

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.observer.disconnect();
        this.loadProducts();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    } else {
      this.loadProducts();
    }
  }

  isValidHandle(handle) {
    return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle);
  }

  readHandles() {
    try {
      const value = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  writeHandles(handles) {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(handles));
    } catch (_) {
      return;
    }
  }

  async loadProducts() {
    const cards = await Promise.all(this.handlesToDisplay.map((handle) => this.loadCard(handle)));
    const grid = this.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    cards.filter(Boolean).forEach((card) => grid.append(card));
    if (grid.childElementCount > 0) this.classList.remove('recently-viewed-products--pending');
  }

  async loadCard(handle) {
    try {
      const requestUrl = `${this.productUrlBase}${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.sectionId)}`;
      const response = await fetch(requestUrl);
      if (!response.ok) return null;

      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const source = parsed.querySelector('template[data-recent-product-source]');
      return source?.content.firstElementChild?.cloneNode(true) || null;
    } catch (_) {
      return null;
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
